import React from 'react';
import '../hero.css';
import { Label } from '@nooz-optics/nooz-components-lib';
import { BannerDesktopImage } from '../BannerDesktopImage/bannerDesktopImage';
import { BannerProps } from './index';
import { TextBanner } from '../BannerText/bannerText';
import { Image } from '../../../UI/Media/Image';
import { BannerButtons } from '../BannerButtons/bannerButtons';
import { useMediaQuery } from '../../../../utils/hooks/useMediaQuery';
import { SplitMediaCrmFormPanel } from '../../Panel/Split';

export const ImageLeftTextMediumBanner = ({
  label,
  body,
  image,
  desktopImage,
}: BannerProps) => (
  <div
    id='hero-left-text-medium'
    style={{ backgroundColor: desktopImage.bgColor }}
    className='flex flex-col-reverse overflow-hidden md:flex-row w-screen h-screen-2/3 justify-center items-center relative'
  >
    {/* Desktop Image */}
    <div className='relative md:hidden h-full w-full'>
      <Image {...image} objectFit='cover' width='100%' height='100%' />
    </div>
    {/* Mobile & Tablet Image */}
    <BannerDesktopImage desktopImage={desktopImage} placement='right' />
    {/* Text Label */}
    <TextBanner placement='left' label={label} body={body} />
  </div>
);

export const ImageLeftTextSlimBanner = ({
  label,
  body,
  image,
  desktopImage,
  badges,
  buttons,
}: BannerProps) => (
  <div
    style={{ backgroundColor: desktopImage.bgColor }}
    id='hero-left-text-slim'
    className='flex flex-col-reverse overflow-hidden md:flex-row w-screen h-96 justify-center items-center relative'
  >
    {/* Desktop Image */}
    <div className='relative md:hidden h-full w-full'>
      <Image {...image} objectFit='cover' width='100%' height='100%' />
    </div>
    <BannerDesktopImage desktopImage={desktopImage} placement='right' />
    {/* Text Label */}
    <TextBanner
      placement='left'
      label={label}
      body={body}
      badges={badges}
      buttons={buttons}
    />
  </div>
);

export const ImageLeftTextFaceHighLightBanner = ({
  label,
  body,
  desktopImage,
  image,
  buttons,
}: BannerProps) => {
  const isWindowSmall = useMediaQuery('sm');
  const imageLeftTextLabelSize = isWindowSmall
    ? '5xl'
    : label.size
    ? label.size
    : '6xl';

  return (
    <div
      style={{ background: desktopImage.bgColor }}
      id='image-left-text-face-highlight-hero'
      className='overflow-hidden border-t border-b w-screen relative flex justify-center items-start flex-col lg:h-128 lg:flex-row lg:py-10'
    >
      {/* Mobile Image */}
      <div className='lg:hidden h-96 w-full'>
        <Image
          {...(image || desktopImage)}
          isNative
          objectFit='cover'
          width='100%'
          height='100%'
        />
      </div>
      {/* Desktop & Tablet Image */}
      <div className='hidden absolute top-0 lg:flex justify-end h-full w-screen'>
        <div className='flex justify-end w-auto h-full'>
          <Image {...desktopImage} isNative height='100%' />
        </div>
      </div>
      {/* Text Label */}
      <div className='main-wrapper h-full items-start flex w-full'>
        <div
          className={`flex-1 border-t h-full border-${label.color?.classname ||
            'white'} relative flex items-center justify-start`}
        >
          <div className='flex flex-col pt-6 lg:w-7/12'>
            <Label
              {...label}
              size={imageLeftTextLabelSize}
              weight='medium'
              color={label.color || { classname: 'white' }}
            />
            <div className='pl-0 lg:pl-10 mt-8 mb-6'>
              <div className='mb-8'>
                <Label
                  {...body}
                  weight='light'
                  family='font-inter'
                  size='xl'
                  color={body?.color || { classname: 'white' }}
                />
              </div>
              <div className='w-full mt-4 flex justify-start'>
                <BannerButtons buttons={buttons} size='lg' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CrmFormBanner = (props) => (
  <div className='w-screen'>
    <div className='main-layout'>
      <SplitMediaCrmFormPanel {...props} />
    </div>
  </div>
);
